import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const globalRoutes = {
    GET_LIST_BY_KIND: "global/unity/findByKind",
    EDIT_PASSWORD: "global/edit-password-first-time",
};

export default {
    getUnityListByKinds(kind, type) {
        return new Promise((resolve) => {
            let newData = [];
            http.get(globalRoutes.GET_LIST_BY_KIND, {params: {kindId: kind}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron los " + type);
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar los " + type);
                        return;
                    }
                    const payMethods = data.info;
                    this.proccessOption(payMethods);
                    newData = payMethods;
                })
                .catch(() => {
                    toast.error("Error al consultar los " + type);
                })
                .finally(() => {
                    resolve(newData);
                });
        });
    },
    proccessOption(unitys) {
        unitys.forEach(value => {
                value.id = value.code;
                value.label = value.title;
            }
        );
    },
    editPassword(newPassword, secretAccess) {
        return new Promise((resolve) => {
            let newData = [];
            const encodedSecretAccess = encodeURIComponent(secretAccess);
            http.put(`${globalRoutes.EDIT_PASSWORD}?newPassword=${newPassword}&access=${encodedSecretAccess}`)
                .then(({data}) => {
                    const code = data.code;
                    if (code < 0) {
                        toast.error(data, 1000 * 10);
                        return;
                    }
                    newData = data;
                })
                .catch(() => {
                    toast.error("No se pudo realizar la conexión con el servidor");
                })
                .finally(() => {
                    resolve(newData);
                });
        });
    },
};
